
<template>
  <form-card :label-text="$t('api.branch.fields.merchant_block.label')">
    <el-table :data="tableList">
      <el-table-column
        label="#"
        width="45"
      >
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <div>{{ scope.row.tooltip }}</div>
            <div slot="reference" class="name-wrapper">
              {{ scope.$index + 1 }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('api.branch.fields.merchant_block.remark_phone.label')"
        prop="phone"
      >
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <div>{{ scope.row.tooltip }}</div>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.phone }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('api.branch.fields.merchant_block.eatigo_uid.label')"
        prop="eatigoUid"
      >
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <div>{{ scope.row.tooltip }}</div>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.eatigoUid }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('api.branch.fields.merchant_block.funnow_uid.label')"
        prop="funnowUid"
      >
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <div>{{ scope.row.tooltip }}</div>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.funnowUid }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
  </form-card>
</template>

<script>
import { BrandID } from '@/enums/brand'
import { BLOCK_REASON_TO_I18N_KEY_MAP } from '@/enums/block'

export default {
  name: 'merchant-block',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tableList () {
      return this.list.map((item) => {
        const blockReason = item.reasons[0]
        const reasonText = BLOCK_REASON_TO_I18N_KEY_MAP[blockReason] ? this.$t(BLOCK_REASON_TO_I18N_KEY_MAP[blockReason]) : this.$t('customer_profile_block_reason_undefined')
        return {
          id: item.phone,
          phone: item.phone,
          funnowUid: item.brand_id_to_hide_uid[BrandID.FunNow] || '',
          nicedayUid: item.brand_id_to_hide_uid[BrandID.NiceDay] || '',
          eatigoUid: item.brand_id_to_hide_uid[BrandID.Eatigo] || '',
          tooltip: this.$t('api.branch.fields.merchant_block.block_reason_tooltip.label', { reason: reasonText, remark: item.remark })
        }
      })
    }
  }
}
</script>
